import React, {useState} from 'react';

import {DNA_OLIGO_SEARCH_TYPE} from 'constants/ModelTypeConstants';
import {SequenceSummary} from 'constants/SequenceConstants';
import OligoMetadata from 'molbio/components/OligoMetadata';
import {SearchContext} from 'search/SearchConstants';
import BioentityChip from 'ui-library/chips/BioentityChip';
import {ChipSize} from 'ui-library/chips/Chip';
import ChipSearchInput, {deprecatedSearchGet} from 'ui-library/inputs/ChipSearchInput';

export default function PrimerSearchInput({
  primerId,
  setPrimerId,
  isReadOnly,
}: {
  primerId: string | null;
  setPrimerId: (value: string | null) => void;
  isReadOnly: boolean;
}): JSX.Element {
  const [query, setQuery] = useState('');
  return (
    <ChipSearchInput
      isMulti={false}
      disableTyping={primerId != null}
      disabled={isReadOnly}
      searchURL={`/1/api/all/search?filter=${DNA_OLIGO_SEARCH_TYPE}`}
      doSearch={deprecatedSearchGet}
      autoFocus={false}
      searchOnEmptyQuery={false}
      placeholder="Search by name"
      fetchParams={{context: SearchContext.LISTING}}
      getOptionDatasFromResponse={(response) =>
        response.data.map((primer: SequenceSummary) => ({
          name: (
            <OligoMetadata
              name={primer.name}
              folderName={primer.folder.name}
              bases={primer.bases!}
              nucleotideType={primer.nucleotideType}
            />
          ),
          value: primer.id,
        }))
      }
      onSelect={(primerId: string) => {
        setQuery('');
        setPrimerId(primerId);
      }}
      value={primerId ? [primerId] : []}
      query={query}
      onQueryChange={(e) => {
        setQuery(e.target.value);
      }}
      renderChips={(primerIds) => (
        <>
          {primerIds.map((primerId) => (
            <BioentityChip
              id={primerId}
              size={ChipSize.MINI}
              onRemove={() => {
                setPrimerId(null);
              }}
              key={primerId}
            />
          ))}
        </>
      )}
    />
  );
}
